import React from "react";
import axios from "axios";
import userProfile from "../assets/images/user-avatar.png";
import { fontsName } from "../assets/fonts/fontsName";

const BestStudentPart = ({ student }) => {
  const [studentPicture, setStudentPicture] = React.useState(null);
  React.useEffect(() => {
    if (student && student.pictureLink !== "") {
      axios
        .get(student.pictureLink)
        .then((res) => {
          setStudentPicture(student.pictureLink);
        })
        .catch((err) => {
          setStudentPicture(null);
        });
    }
  }, [student]);

  return (
    <div
      className="single-blog-post bg-fffbf5"
      style={{ borderRadius: "15px" }}
    >
      <div className="post-image" style={{ borderRadius: "15px" }}>
        <img
          src={studentPicture !== null ? studentPicture : userProfile}
          alt="best-student"
          style={{ height: "350px", borderRadius: "15px" }}
        />
      </div>

      <div
        className="post-content"
        style={{
          direction: "rtl",
          fontFamily: fontsName.BNazanin,
        }}
      >
        <h3
          style={{
            direction: "rtl",
            fontFamily: fontsName.BNazanin,
            textAlign: "right",
          }}
        >
          {student.fullName}
        </h3>
        <p
          style={{
            direction: "rtl",
            fontFamily: fontsName.BNazanin,
            textAlign: "right",
            paddingTop: "5px",
            fontSize: "20px",
          }}
        >
          {student.level}
        </p>
      </div>
    </div>
  );
};

export default BestStudentPart;
